import React from 'react'
import {FaReact} from 'react-icons/fa'
import './Biography.css'


const Biography = () => {
  return (
    <>
      <section className='biography-section'>
        <div className='upper-wrapper'>
          <div className='bar3'></div>
          <div className='wrapper-child'>
            <span><FaReact/></span>
            <h1>Trajetória acadêmica</h1>
          </div>
        </div>
        <div className='biography-wrapper'>
        <p>Fiz meu mestrado na Universidade de Debrecen com bolsista do Stipendium Hungaricum. Em minhas aplicações de estudo no exterior, já ganhei carta de admissão incondicional em universidades da Alemanha, Espanha, Hungria, Nova Zelândia e do Reino Unido. E ganhei admissão condicional em universidades do Canadá e da Austrália. Já fui contemplada com 6 bolsas de estudos no total. Meu Primeiro intercâmbio foi na Illinois State University, USA. E o segundo na Universidad de Jaén, Espanha.</p>
<br />
<p>Amo aprender novos idiomas, consigo me comunicar em Português, Inglês e Espanhol. Agora estou aprendendo o Húngaro. Sou voluntária @duolingo, onde sou Global Ambassador e apoio a missão da empresa de levar educação gratuita a toda parte do mundo. Em 2020, fui escolhida entre mais de 4800 pessoas para ser embaixadora da @worldliteracy_foundation, ajudei a promover ações que minimizem os impactos da pobreza e do analfabetismo.</p>
< br />
<p>Na Espanha surgiu a ideia da Easy Tramitt, eu já tinha vontade de trabalhar com pessoas que sonham com um intercâmbio, vi que no país tem muito apoio ao empreendedor. Então decidi participar de uma competição de empreendedores da Universidade de Jaén, chamada "PROGRAMA INSIDE UJA", com a ideia pude ganhar prêmios.</p>
</div>
      </section>
    </>
  )
}

export default Biography
